import type { ReactNode, ComponentPropsWithRef, ElementType } from 'react';
import { Button, type ButtonProps, type DistributiveOmit } from '../ui/Button';

interface CTAButtonProps {
  className?: string;
  title?: string;
  iconClassName?: string;
  children?: ReactNode;
  showBottomHighlight?: boolean;
}

export const CTAButton = <TAs extends ElementType>({
  className,
  children = 'Log in',
  showBottomHighlight = true,
  ...rest
}: CTAButtonProps &
  ButtonProps<TAs> &
  DistributiveOmit<ComponentPropsWithRef<ElementType extends TAs ? 'button' : TAs>, 'as'>) => {
  return (
    <Button {...rest} className={className}>
      {children}
      {showBottomHighlight && (
        <span className="from-primary-500/0 via-primary-500/90 to-primary-500/0 absolute -bottom-0 left-[1.125rem] h-px w-[calc(100%-2.25rem)] bg-gradient-to-r transition-opacity duration-500 group-hover:opacity-40"></span>
      )}
    </Button>
  );
};
